export default __webpack_public_path__ + "static/media/Logo.af178a61.png";